var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankTranferIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 12.1282C12.6129 11.6609 12.2446 11.2821 11.7903 11.2821H5.20968C4.75538 11.2821 4.3871 11.6609 4.3871 12.1282C4.3871 12.5955 4.75538 12.9744 5.20968 12.9744H11.7903C12.2446 12.9744 12.6129 12.5955 12.6129 12.1282Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6129 16.641C12.6129 16.1737 12.2446 15.7949 11.7903 15.7949H5.20968C4.75538 15.7949 4.3871 16.1737 4.3871 16.641C4.3871 17.1083 4.75538 17.4872 5.20968 17.4872H11.7903C12.2446 17.4872 12.6129 17.1083 12.6129 16.641Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01613 0C1.35037 0 0 1.38906 0 3.10256V18.8974C0 20.6109 1.35037 22 3.01613 22H13.9839C15.6496 22 17 20.6109 17 18.8974V6.45069C17 6.0211 16.8638 5.60324 16.612 5.26048L13.3241 0.78415C12.9614 0.290285 12.3945 0 11.7928 0H3.01613ZM1.64516 3.10256C1.64516 2.3237 2.25896 1.69231 3.01613 1.69231H10.9677V6.65308C10.9677 7.1204 11.336 7.49923 11.7903 7.49923H15.3548V18.8974C15.3548 19.6763 14.741 20.3077 13.9839 20.3077H3.01613C2.25896 20.3077 1.64516 19.6763 1.64516 18.8974V3.10256Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTranferIcon);
export default __webpack_public_path__ + "static/media/bank-tranfer-icon.07c193a9c10d9cfa108d577f811f4999.svg";
export { ForwardRef as ReactComponent };